var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _ellipse, _ellipse2, _path10, _ellipse3, _ellipse4, _circle, _polygon, _path11, _path12, _path13, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _path14, _path15, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProjectDirector(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "e2d57332-5c77-46ba-a509-f532ebdeb05d",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 772.72109,
    height: 669.07003,
    viewBox: "0 0 772.72109 669.07003",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M401.93865,223.56243h0c-21.46488,0-37.09156,16.04147-42.3595,38.94395l-6.53052,34.358h4.64648l10.06738-28.1275-2.11943,28.1275h5.21708l3.87207-14.48993-.81515,14.48993h62.76826v-35.0586c0-21.12124-15.5566-38.24337-34.74662-38.24336Z",
    transform: "translate(-213.63946 -115.46498)",
    fill: "#2f2e41"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M373.57055,407.99278s-31.751,44.14158-30.20214,61.9531S365.052,778.1626,365.052,778.1626l47.23925,2.32324L398.35179,571.39411l11.6162-56.5322L438.6213,778.1626l58.081,1.54882L444.81661,438.19494,434.74924,407.9928Z",
    transform: "translate(-213.63946 -115.46498)",
    fill: "#2f2e41"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M384.41234,273.24476s10.06738,18.58594-3.09766,30.97656-19.36034,45.69041-19.36034,45.69041l74.34372-5.4209-6.19531-41.81834s-16.26269-10.06738-12.39062-27.8789Z",
    transform: "translate(-213.63946 -115.46498)",
    fill: "#ffb8b8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M372.02172,322.80725s4.64648,13.93945,24.78124,12.39062a69.0948,69.0948,0,0,0,34.07421-12.39062v90.6064l-61.95311-2.32324V356.107Z",
    transform: "translate(-213.63946 -115.46498)",
    fill: "#75b5ff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M375.89379,413.41365l4.64648-15.48828s-1.54883-36.39744-7.74414-51.11131c0,0,11.83789-38.78559,13.66308-49.98213l-5.91894,4.29173-35.623,17.03711,12.39063,64.27633,8.51855,13.93945L357,433Z",
    transform: "translate(-213.63946 -115.46498)",
    fill: "#3f3d56"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M406.09592,410.316l17.81152-96.80173-4.88822-24.00684,14.18119,13.93945,27.87889,8.51855-13.165,72.79489-7.74414,15.48828L444,435Z",
    transform: "translate(-213.63946 -115.46498)",
    fill: "#3f3d56"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M477.342,475.36678s7.74414,33.29979-7.74413,37.17186-10.06738-37.17186-10.06738-37.17186Z",
    transform: "translate(-213.63946 -115.46498)",
    fill: "#ffb8b8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M340.744,440.80355s29.8202,16.72134,22.24239,30.77328-34.24654-17.6146-34.24654-17.6146Z",
    transform: "translate(-213.63946 -115.46498)",
    fill: "#ffb8b8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M449.4631,313.51428l11.6162-1.54883s6.96973,9.293,7.74414,16.26269,13.165,124.68061,13.165,124.68061c.89138,2.56944.01152,5.09125-.77442,26.33007l-2.32324,9.293s-4.64648-17.81152-22.458-8.51855l-2.32324-10.8418s-4.64648-41.04393-4.64648-60.40427-1.54883-40.26952-1.54883-40.26952Z",
    transform: "translate(-213.63946 -115.46498)",
    fill: "#3f3d56"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 179.72159,
    cy: 663.86442,
    rx: 11.01198,
    ry: 4.12948,
    fill: "#2f2e41"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 254.05238,
    cy: 663.86442,
    rx: 11.01198,
    ry: 4.12948,
    fill: "#2f2e41"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M353.43579,317.38635l-8.51856.77442-19.36034,75.11812s-2.352,97.538,17.0371,78.99021c0,0-6.96972-20.13476,10.8418-27.10448V404.12069l6.19531-35.623Z",
    transform: "translate(-213.63946 -115.46498)",
    fill: "#3f3d56"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 214.14007,
    cy: 150.42286,
    rx: 1.16162,
    ry: 3.87207,
    fill: "#ffb8b8"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 161.47993,
    cy: 150.42286,
    rx: 1.16162,
    ry: 3.87207,
    fill: "#ffb8b8"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 187.81,
    cy: 148.48682,
    r: 25.55566,
    fill: "#ffb8b8"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "176.581 134.935 175.928 141.13 193.618 141.13 195.942 136.483 195.452 141.13 216.851 141.13 202.137 117.898 169.612 118.672 161.867 141.13 173.484 141.13 176.581 134.935",
    fill: "#2f2e41"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M779.36054,541.37612c-114.14062,0-207-92.86035-207-207.00049s92.85938-207,207-207,207,92.85986,207,207S893.50117,541.37612,779.36054,541.37612Zm0-412.00049c-113.03711,0-205,91.9624-205,205s91.96289,205.00049,205,205.00049,205-91.96289,205-205.00049S892.39765,129.37563,779.36054,129.37563Z",
    transform: "translate(-213.63946 -115.46498)",
    fill: "#e6e6e6"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M779.36054,483.37612c-82.15918,0-149-66.84131-149-149.00049,0-82.15869,66.84082-149,149-149s149,66.84131,149,149C928.36054,416.53481,861.51972,483.37612,779.36054,483.37612Zm0-296.00049c-81.05566,0-147,65.94385-147,147s65.94434,147.00049,147,147.00049,147-65.94434,147-147.00049S860.41621,187.37563,779.36054,187.37563Z",
    transform: "translate(-213.63946 -115.46498)",
    fill: "#e6e6e6"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M779.36054,424.71743a90.34156,90.34156,0,1,1,90.3418-90.3418A90.44435,90.44435,0,0,1,779.36054,424.71743Zm0-178.68311a88.34156,88.34156,0,1,0,88.3418,88.34131A88.44164,88.44164,0,0,0,779.36054,246.03432Z",
    transform: "translate(-213.63946 -115.46498)",
    fill: "#e6e6e6"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 565.7211,
    cy: 218.91089,
    r: 45.87339,
    fill: "#75b5ff"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 598.53905,
    cy: 14.54522,
    r: 14.54522,
    fill: "#75b5ff"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 416.16438,
    cy: 360.2739,
    r: 14.54522,
    fill: "#75b5ff"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 418.16438,
    cy: 235.2739,
    r: 14.54522,
    fill: "#e6e6e6"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 690.16438,
    cy: 137.2739,
    r: 14.54522,
    fill: "#e6e6e6"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 747.16438,
    cy: 318.2739,
    r: 14.54522,
    fill: "#e6e6e6"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 704.83104,
    cy: 253.98191,
    r: 14.54522,
    fill: "#75b5ff"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 385.95507,
    cy: 115.24289,
    r: 14.54522,
    fill: "#75b5ff"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 619.79745,
    cy: 418.45478,
    r: 14.54522,
    fill: "#75b5ff"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M222.99144,762.8808c14.41965,19.311,44.352,21.34353,44.352,21.34353s6.55352-29.27679-7.86613-48.58779-44.352-21.34353-44.352-21.34353S208.57179,743.5698,222.99144,762.8808Z",
    transform: "translate(-213.63946 -115.46498)",
    fill: "#e6e6e6"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M296.44816,770.14037c-9.51509,12.74276-29.26658,14.084-29.26658,14.084s-4.32447-19.31888,5.19063-32.06163,29.26658-14.08395,29.26658-14.08395S305.96326,757.39762,296.44816,770.14037Z",
    transform: "translate(-213.63946 -115.46498)",
    fill: "#e6e6e6"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.17557,
    y: 666.82931,
    width: 664,
    height: 2.24072,
    fill: "#3f3d56"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectDirector);
export default __webpack_public_path__ + "static/media/project_director.df1d9392ca4aefb79d5b424d22c2f262.svg";
export { ForwardRef as ReactComponent };